import { FormControlProps } from '@chakra-ui/form-control';
import { useMergeRefs } from '@telescope/cassini-hooks';
import { FormControl, FormLabel, FormHelperText, FormErrorMessage, RadioGroup, Radio, HStack } from '@telescope/cassini-ui';
import React, { forwardRef } from 'react';
import { useController, UseControllerProps } from 'react-hook-form';

type RadioFieldProps = UseControllerProps &
  FormControlProps & { 
    helpText?: string; 
    options: {label: string, value: string | boolean}[]
  };

export const RadioField = forwardRef<HTMLSelectElement, RadioFieldProps>(
  (
    {
      isRequired,
      label,
      helpText,
      isDisabled,
      isReadOnly,
      name,
      rules,
      shouldUnregister,
      defaultValue,
      control,
      options,
      ...formControlProps
    },
    ref
  ) => {
    const {
      field: { onChange, onBlur, value, ref: fieldRef },
      fieldState: { error },
    } = useController({
      name,
      rules,
      defaultValue,
      shouldUnregister,
    });
    const radioElRef = useMergeRefs(ref, fieldRef);

    return (
      <FormControl
        isInvalid={!!error}
        isRequired={isRequired}
        isDisabled={isDisabled}
        isReadOnly={isReadOnly}
        {...formControlProps}>
        <FormLabel>{label}</FormLabel>

        <RadioGroup 
          name={name}
          ref={radioElRef}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          >
          <HStack>
            {options.map((option: any) => (
              <Radio value={option.value} key={option.value}>{option.label}</Radio>
            ))}
          </HStack>
        </RadioGroup>

        {error && <FormErrorMessage>{error.message}</FormErrorMessage>}
        {helpText && <FormHelperText>{helpText}</FormHelperText>}
      </FormControl>
    );
  }
);
